import { takeLatest, call, put, all } from 'redux-saga/effects';
import { store } from '../redux/store';

import { 
  fetchMonthlyReport,
  fetchMonthlyReportChart,
  fetchMonthlyReportChartForPortFolios
} from '../_services/monthly-report.services';

import { 
  fetchMonthlyReportSuccess, 
  fetchMonthlyReportFailure,
  fetchMonthlyReportChartSuccess,
  fetchMonthlyReportChartFailure,
  clearMonthluReportTableQueries,
  clearMonthluReportChartQueries,
  clearMonthluReportSharedQueries
} from '../_actions/monthly-report.actions';

import { monthlyReportConstants } from '../_constants/monthly-report.constants';

export function* fetchMonthlyReportTableStartAsync() {
  const state = store.getState();
  const account = state.investment.userAccounts;
  const sharedQueries = state.monthlyReport.sharedQueries;
  const tableQueries = state.monthlyReport.monthlyReportTable.queries;
  
  let payload = {
    accountNumber: account.map(acc => acc.accountNumber)[0],
    date: sharedQueries.date,
    groupType: tableQueries.groupType,
    sortBy: tableQueries.sortKey,
    sortType: tableQueries.sortType
  }

  try {
    const result = yield call(fetchMonthlyReport, payload);
    yield put(fetchMonthlyReportSuccess(result.data));
  } catch (error) {
    yield put(fetchMonthlyReportFailure(error.message));
  }
}

export function* fetchMonthlyReportChartStartAsync() {
  try {  
    const state = store.getState();
    let payload = {};
    let result = null;

    if (state.main.currentPage === 'MONTHLY_REPORT') {
      payload['accountNumber'] = state.investment.userAccounts[0]?.accountNumber;
      payload['date'] = state.monthlyReport.sharedQueries.date;
      result = yield call(fetchMonthlyReportChart, payload);
    } else if (state.main.currentPage === 'INVESTMENT') {
      payload['accountNumbers'] = state.investment.userAccounts.map(x => x.accountNumber);
      result = yield call(fetchMonthlyReportChartForPortFolios, payload);
    } else {
      // THROW ERROR WHEN CURRENT PAGE IS NOT BOTH INVESTMENT AND MONTHLY_REPORT.
      const error = new Error( "Your page not permission to access this content.");
      throw(error);
    }

    yield put(fetchMonthlyReportChartSuccess(result.data));
  } catch (error) {
    yield put(fetchMonthlyReportChartFailure(error.message));
  }
}

export function* clearMonthlyReportQueriesStart() {
  yield put(clearMonthluReportTableQueries());
  yield put(clearMonthluReportChartQueries());
  yield put(clearMonthluReportSharedQueries());
}

export function* fetchMonthlyReportTableStart() {
  yield takeLatest(monthlyReportConstants.FETCH_MONTHLY_REPORT_START, fetchMonthlyReportTableStartAsync);
}

export function* fetchMonthlyReportChartStart() {
  yield takeLatest(monthlyReportConstants.FETCH_MONTHLY_REPORT_CHART_START, fetchMonthlyReportChartStartAsync);
}

export function* clearQueriesStart() {
  yield takeLatest(monthlyReportConstants.CLEAR_MONTHLY_REPORT_QUERIES_START, clearMonthlyReportQueriesStart);
}

export function* monthlyReportSagas() {
  yield all([call(fetchMonthlyReportTableStart), call(fetchMonthlyReportChartStart), call(clearQueriesStart)]);
}
